export enum TimelineEventsEnum {
  CLIP_DRAG_OVER_DIVIDER = "timeline:divider:over",
}

export type ClipDragOverDividerEvent = { clipId: string; index: number };
